import { render, staticRenderFns } from "./PlanDetailPage.vue?vue&type=template&id=2f9b39c6&scoped=true"
import script from "./PlanDetailPage.vue?vue&type=script&lang=js"
export * from "./PlanDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PlanDetailPage.vue?vue&type=style&index=0&id=2f9b39c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9b39c6",
  null
  
)

export default component.exports